import get from 'lodash/get';
import findIndex from 'lodash/findIndex';
import isEmpty from 'lodash/isEmpty';
import TokenProvider from 'yoda-core-components/lib/helpers/TokenProvider/TokenProvider';
import LocalStorage from 'yoda-core-components/lib/helpers/LocalStorage/LocalStorage';

export const getSavedItems = (status, ppId, itemId, listId, removeAll = false) => {
    if (status && status !== '0') {
        return '';
    }
    let savedItems;
    let payLoadData;
    let data = '';
    let savedForLater = false;
    /**
     * Only for myFavorites at the moment
     */
    if (removeAll) {
        LocalStorage.removeData('DP_SAVED_ITEMS_PAYLOAD');
        LocalStorage.removeData('DP_SAVED_ITEMS');
        return data;
    }
    if (listId !== 'savedForLater' && TokenProvider.get('DP_SAVED_ITEMS_PAYLOAD')) {
        savedItems = JSON.parse(TokenProvider.get('DP_SAVED_ITEMS_PAYLOAD'));
        payLoadData = savedItems.slice(0);
    } else if (listId === 'savedForLater' && TokenProvider.get('DP_CHECKOUT_SAVED_ITEMS_PAYLOAD')) {
        savedItems = JSON.parse(TokenProvider.get('DP_CHECKOUT_SAVED_ITEMS_PAYLOAD'));
        payLoadData = savedItems.slice(0);
        savedForLater = true;
    }
    if (savedItems) {
        savedItems.reverse();
        payLoadData.reverse();
        for (let i = 0; i < savedItems.length; i += 1) {
            if (savedItems[i] && savedItems[i].itemId && savedItems[i].itemId !== itemId) {
                data = `${data}${savedItems[i].product.id}:${savedItems[i].itemId},`;
            } else if (
                savedItems[i] &&
                savedItems[i].product.id &&
                savedItems[i].product.id !== ppId
            ) {
                data = `${data}${savedItems[i].product.id}:,`;
            } else {
                payLoadData.splice(i, 1);
            }
        }
    }
    const savedItemObj = {};
    if (payLoadData && !savedForLater) {
        TokenProvider.set('DP_SAVED_ITEMS_PAYLOAD', JSON.stringify(payLoadData));
        for (let i = 0; i < payLoadData.length; i += 1) {
            savedItemObj[payLoadData[i].product.id] = {
                id: payLoadData[i].product.id,
            };
        }
        TokenProvider.set('DP_SAVED_ITEMS_COUNT', JSON.stringify(payLoadData.length));
        TokenProvider.set('DP_SAVED_ITEMS', JSON.stringify(savedItemObj));
    } else if (payLoadData) {
        TokenProvider.set('DP_CHECKOUT_SAVED_ITEMS_PAYLOAD', JSON.stringify(payLoadData));
    }
    return data;
};

export const updateMostWanted = (id, mostWanted) => {
    if (isEmpty(id)) {
        return;
    }
    const saveItemsValue = TokenProvider.get('DP_SAVED_ITEMS_PAYLOAD');
    let savedItems = JSON.parse(saveItemsValue);
    savedItems = savedItems.map((item) => {
        const productId = get(item, 'product.id', '');
        const itemId = get(item, 'itemId', '') || ''; // itemId return null some times
        const uuid = `${productId}-${itemId}`;
        if (uuid === id) {
            return {
                ...item,
                mostWanted,
            };
        }
        return item;
    });
    TokenProvider.set('DP_SAVED_ITEMS_PAYLOAD', JSON.stringify(savedItems));
};

export const addSavedItemToLocal = (newItem) => {
    const saveItemsValue = TokenProvider.get('DP_SAVED_ITEMS_PAYLOAD') || '[]';
    const savedItems = JSON.parse(saveItemsValue);

    const newProductId = get(newItem, 'id', '');
    const newItemId = get(newItem, 'itemId', '') || ''; // itemId return null some times
    const newUUID = `${newProductId}-${newItemId}`;

    const fIndex = findIndex(savedItems, (item) => {
        const productId = get(item, 'product.id', '');
        const itemId = get(item, 'itemId', '') || ''; // itemId return null some times
        const uuid = `${productId}-${itemId}`;
        return uuid === newUUID;
    });
    if (fIndex === -1) {
        const data = TokenProvider.get('DP_SAVED_ITEMS') || '{}';
        const keySavedItems = JSON.parse(data);
        keySavedItems[newProductId] = { id: newProductId };
        TokenProvider.set('DP_SAVED_ITEMS', JSON.stringify(keySavedItems));
        savedItems.push({ product: { id: newProductId }, itemId: get(newItem, 'itemId', null) });
        TokenProvider.set('DP_SAVED_ITEMS_PAYLOAD', JSON.stringify(savedItems));
        TokenProvider.set('DP_SAVED_ITEMS_COUNT', JSON.stringify(savedItems.length));
        TokenProvider.set('DP_USER_FAVCOUNT', JSON.stringify(savedItems.length));
        return savedItems.length;
    }
    return -1;
};

export const removeSavedItemAtLocal = (newItem) => {
    const saveItemsValue = TokenProvider.get('DP_SAVED_ITEMS_PAYLOAD') || '[]';
    const savedItems = JSON.parse(saveItemsValue);

    const newProductId = get(newItem, 'id', '');
    const newItemId = get(newItem, 'itemId', '') || ''; // itemId return null some times
    const newUUID = `${newProductId}-${newItemId}`;

    const newSavedItems = savedItems.filter((item) => {
        const productId = get(item, 'product.id', '');
        const itemId = get(item, 'itemId', '') || ''; // itemId return null some times
        const uuid = `${productId}-${itemId}`;
        return uuid !== newUUID;
    });
    if (newSavedItems.length !== savedItems.length) {
        TokenProvider.set('DP_SAVED_ITEMS_PAYLOAD', JSON.stringify(newSavedItems));
        TokenProvider.set('DP_SAVED_ITEMS_COUNT', JSON.stringify(newSavedItems.length));
        removeDPSavedItems(newItem, true);
    }
};

export const removeDPSavedItems = (deleteItemDetails, isItemCountUpdated = false) => {
    const saveItemsValue = TokenProvider.get('DP_SAVED_ITEMS') || '{}';
    const savedItems = JSON.parse(saveItemsValue);
    const SavedItemsLength = Object.keys(savedItems).length;
    if (SavedItemsLength > 1) {
        savedItems[deleteItemDetails.id] && delete savedItems[deleteItemDetails.id];
        TokenProvider.set('DP_SAVED_ITEMS', JSON.stringify(savedItems));
        !isItemCountUpdated &&
            TokenProvider.set('DP_SAVED_ITEMS_COUNT', JSON.stringify(SavedItemsLength - 1));
    } else {
        LocalStorage.removeData('DP_SAVED_ITEMS');
        !isItemCountUpdated && TokenProvider.set('DP_SAVED_ITEMS_COUNT', JSON.stringify(0));
    }
};

export const getHighPriorityItems = () => {
    const saveItemsValue = TokenProvider.get('DP_SAVED_ITEMS_PAYLOAD');
    if (isEmpty(saveItemsValue)) {
        return [];
    }
    const savedItems = JSON.parse(saveItemsValue);
    return savedItems.reduce((result, item) => {
        const productId = get(item, 'product.id', '');
        const itemId = get(item, 'itemId', '') || '';
        const uuid = `${productId}-${itemId}`;
        // eslint-disable-next-line no-param-reassign
        result[uuid] = { mostWanted: !!item.mostWanted, quantity: item.quantity };
        return result;
    }, {});
};
